/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryQuestionStatus extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryQuestionStatus");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryQuestionStatus.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryQuestionStatus>): AssessmentViewQueryQuestionStatus {
        let obj = Object.assign(new AssessmentViewQueryQuestionStatus(), model);
        AssessmentViewQueryQuestionStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryQuestionStatus>): AssessmentViewQueryQuestionStatus {
        if (!model) return null;
        return AssessmentViewQueryQuestionStatus.newInstance(<AssessmentViewQueryQuestionStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryQuestionStatus) {
        if (!obj) return;

        models.AssessmentViewQueryQuestionStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryQuestionStatus): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryQuestionStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Status of question
     */
    question_statuses: Array<models.WellArchitectedFrameworkAssessmentRunAnswerStatus>;

}
